"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUBSCRIBE_LINKS_ORDER = exports.DEFAULT_SETTINGS_LINKS = exports.DEFAULT_SETTINGS_COLORS = exports.DEFAULT_SETTINGS_FONTS = exports.DEFAULT_SETTINGS_EPISODE = exports.DEFAULT_SETTING_MAIN = exports.DEFAULT_SETTING_COMMON = exports.SETTINGS_VERSION = exports.SettingsPubSubEvent = exports.ButtonStyle = exports.EpisodesGridTextPosition = exports.EpisodesGridTextAlignment = exports.EpisodesLayout = exports.MainHeaderTextAlignment = exports.MainHeaderStyle = exports.PodcastServiceType = void 0;
var tslib_1 = require("tslib");
var style_params_1 = require("../style-params");
var MainHeaderStyle;
(function (MainHeaderStyle) {
    MainHeaderStyle["CLASSIC"] = "CLASSIC";
    MainHeaderStyle["MINIMAL"] = "MINIMAL";
})(MainHeaderStyle || (MainHeaderStyle = {}));
exports.MainHeaderStyle = MainHeaderStyle;
var MainHeaderTextAlignment;
(function (MainHeaderTextAlignment) {
    MainHeaderTextAlignment["LEFT"] = "LEFT";
    MainHeaderTextAlignment["CENTER"] = "CENTER";
})(MainHeaderTextAlignment || (MainHeaderTextAlignment = {}));
exports.MainHeaderTextAlignment = MainHeaderTextAlignment;
var EpisodesLayout;
(function (EpisodesLayout) {
    EpisodesLayout["LIST"] = "LIST";
    EpisodesLayout["GRID"] = "GRID";
})(EpisodesLayout || (EpisodesLayout = {}));
exports.EpisodesLayout = EpisodesLayout;
var EpisodesGridTextAlignment;
(function (EpisodesGridTextAlignment) {
    EpisodesGridTextAlignment["LEFT"] = "LEFT";
    EpisodesGridTextAlignment["CENTER"] = "CENTER";
    EpisodesGridTextAlignment["RIGHT"] = "RIGHT";
})(EpisodesGridTextAlignment || (EpisodesGridTextAlignment = {}));
exports.EpisodesGridTextAlignment = EpisodesGridTextAlignment;
var EpisodesGridTextPosition;
(function (EpisodesGridTextPosition) {
    EpisodesGridTextPosition["BELOW"] = "BELOW";
    EpisodesGridTextPosition["ON"] = "ON";
})(EpisodesGridTextPosition || (EpisodesGridTextPosition = {}));
exports.EpisodesGridTextPosition = EpisodesGridTextPosition;
var ButtonStyle;
(function (ButtonStyle) {
    ButtonStyle["ROUND_OUTLINE"] = "ROUND_OUTLINE";
    ButtonStyle["ROUND_FULL"] = "ROUND_FULL";
    ButtonStyle["SQUARE_OUTLINE"] = "SQUARE_OUTLINE";
    ButtonStyle["SQUARE_FULL"] = "SQUARE_FULL";
})(ButtonStyle || (ButtonStyle = {}));
exports.ButtonStyle = ButtonStyle;
var SettingsPubSubEvent;
(function (SettingsPubSubEvent) {
    SettingsPubSubEvent["WIDGET_PAGE_CHANGE"] = "WIDGET_PAGE_CHANGE";
})(SettingsPubSubEvent || (SettingsPubSubEvent = {}));
exports.SettingsPubSubEvent = SettingsPubSubEvent;
var PodcastServiceType;
(function (PodcastServiceType) {
    PodcastServiceType["RSS"] = "RSS";
    PodcastServiceType["APPLE"] = "APPLE";
    PodcastServiceType["SPOTIFY"] = "SPOTIFY";
    PodcastServiceType["GOOGLE"] = "GOOGLE";
    PodcastServiceType["STITCHER"] = "STITCHER";
    PodcastServiceType["SOUND_CLOUD"] = "SOUND_CLOUD";
})(PodcastServiceType || (PodcastServiceType = {}));
exports.PodcastServiceType = PodcastServiceType;
var SETTINGS_VERSION = 1;
exports.SETTINGS_VERSION = SETTINGS_VERSION;
var DEFAULT_SETTING_COMMON = {
    allowDownload: true,
    buttonStyle: ButtonStyle.ROUND_OUTLINE,
};
exports.DEFAULT_SETTING_COMMON = DEFAULT_SETTING_COMMON;
var DEFAULT_SETTING_MAIN = {
    headerStyle: MainHeaderStyle.CLASSIC,
    headerTextAlignment: MainHeaderTextAlignment.LEFT,
    episodesLayout: EpisodesLayout.LIST,
    showHeader: true,
    showHeaderAuthor: true,
    showHeaderDescription: true,
    showEpisodeImage: true,
    showEpisodeDate: true,
    showEpisodeDuration: true,
    showEpisodeDescription: true,
    showLatestEpisodeText: true,
    episodesPerPage: 5,
    episodeRowsPerPage: 2,
    borderWidth: 5,
    dividerWidth: 1,
    episodeListSpacing: 20,
    episodesGridTextAlignment: EpisodesGridTextAlignment.LEFT,
    episodesGridTextPosition: EpisodesGridTextPosition.BELOW,
    episodesGridTextIndent: 20,
    gridItemBorderWidth: 0,
    mobileShowEpisodeImage: true,
    mobileShowEpisodeDate: true,
    mobileShowEpisodeDescription: true,
    mobileShowEpisodeDuration: true,
};
exports.DEFAULT_SETTING_MAIN = DEFAULT_SETTING_MAIN;
var DEFAULT_SETTINGS_EPISODE = {
    borderWidth: 5,
    dropImageShadow: true,
};
exports.DEFAULT_SETTINGS_EPISODE = DEFAULT_SETTINGS_EPISODE;
var DEFAULT_SETTINGS_FONTS = {
    main: {
        headerTitleFont: tslib_1.__assign({ size: 52 }, style_params_1.Fonts.Heading5),
        headerSubtitleFont: tslib_1.__assign({ size: 20 }, style_params_1.Fonts.Paragraph2),
        headerDescriptionFont: tslib_1.__assign({ size: 20 }, style_params_1.Fonts.Paragraph2),
        episodeTitleFont: tslib_1.__assign({ size: 26 }, style_params_1.Fonts.Heading5),
        episodeDescriptionFont: tslib_1.__assign({ size: 16 }, style_params_1.Fonts.Paragraph2),
    },
    episode: {
        headerTitleFont: tslib_1.__assign({ size: 52 }, style_params_1.Fonts.Heading5),
        headerSubtitleFont: tslib_1.__assign({ size: 16 }, style_params_1.Fonts.Paragraph2),
        contentDescriptionFont: tslib_1.__assign({ size: 20 }, style_params_1.Fonts.Paragraph2),
    },
    common: {},
};
exports.DEFAULT_SETTINGS_FONTS = DEFAULT_SETTINGS_FONTS;
var DEFAULT_SETTINGS_COLORS = {
    main: {
        headerTitleColor: { color: style_params_1.Colors.C5, opacity: 1 },
        headerSubtitleColor: { color: style_params_1.Colors.C5, opacity: 1 },
        headerDescriptionColor: { color: style_params_1.Colors.C5, opacity: 1 },
        headerBackgroundColor: { color: style_params_1.Colors.C1, opacity: 1 },
        headerButtonTextColor: { color: style_params_1.Colors.C1, opacity: 1 },
        headerButtonColor: { color: style_params_1.Colors.C8, opacity: 1 },
        episodeTitleColor: { color: style_params_1.Colors.C5, opacity: 1 },
        episodeDescriptionColor: { color: style_params_1.Colors.C5, opacity: 1 },
        episodeListBackgroundColor: { color: style_params_1.Colors.C1, opacity: 1 },
        episodeButtonTextColor: { color: style_params_1.Colors.C1, opacity: 1 },
        episodeButtonColor: { color: style_params_1.Colors.C8, opacity: 1 },
        textColor: { color: style_params_1.Colors.C5, opacity: 1 },
        dividerOpacityColor: { color: style_params_1.Colors.C5, opacity: 0.2 },
        borderOpacityColor: { color: style_params_1.Colors.C1, opacity: 1 },
        episodeTextOnGridTitleColor: { color: style_params_1.Colors.C1, opacity: 1 },
        episodeTextOnGridDescriptionColor: { color: style_params_1.Colors.C1, opacity: 1 },
        gridItemOverlayOpacityColor: { color: style_params_1.Colors.C5, opacity: 0.35 },
        gridItemBackgroundOpacityColor: { color: style_params_1.Colors.C1, opacity: 1 },
        gridItemBorderOpacityColor: { color: style_params_1.Colors.C1, opacity: 1 },
        subscribeLinkHoverColor: { color: style_params_1.Colors.C5, opacity: 1 },
        mobileEpisodeTextColor: { color: style_params_1.Colors.C5, opacity: 1 },
        mobileEpisodeListBackgroundColor: { color: style_params_1.Colors.C1, opacity: 1 },
        mobileDividerOpacityColor: { color: style_params_1.Colors.C5, opacity: 0.2 },
        mobileEpisodeButtonColor: { color: style_params_1.Colors.C8, opacity: 1 },
    },
    episode: {
        headerTitleColor: { color: style_params_1.Colors.C1, opacity: 1 },
        headerSubtitleColor: { color: style_params_1.Colors.C1, opacity: 1 },
        headerBackgroundColor: { color: style_params_1.Colors.C8, opacity: 1 },
        headerButtonTextColor: { color: style_params_1.Colors.C8, opacity: 1 },
        headerButtonColor: { color: style_params_1.Colors.C1, opacity: 1 },
        contentDescriptionColor: { color: style_params_1.Colors.C5, opacity: 1 },
        contentBackgroundColor: { color: style_params_1.Colors.C1, opacity: 1 },
        linkColor: { color: style_params_1.Colors.C8, opacity: 1 },
        playerBackgroundColor: { color: style_params_1.Colors.C8, opacity: 1 },
        playerBorderColor: { color: style_params_1.Colors.C8, opacity: 1 },
        playerControlsColor: { color: style_params_1.Colors.C1, opacity: 1 },
    },
    common: {},
};
exports.DEFAULT_SETTINGS_COLORS = DEFAULT_SETTINGS_COLORS;
var SUBSCRIBE_LINKS_ORDER = [
    PodcastServiceType.RSS,
    PodcastServiceType.APPLE,
    PodcastServiceType.SPOTIFY,
    PodcastServiceType.GOOGLE,
    PodcastServiceType.STITCHER,
    PodcastServiceType.SOUND_CLOUD,
];
exports.SUBSCRIBE_LINKS_ORDER = SUBSCRIBE_LINKS_ORDER;
var DEFAULT_SETTINGS_LINKS = [];
exports.DEFAULT_SETTINGS_LINKS = DEFAULT_SETTINGS_LINKS;
//# sourceMappingURL=constants.js.map